import { ChartSection } from 'Components/Worksheets/PlateLoadingWorksheet/Sections';
import { NamePrefixModifier, withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { IWorksheetComponent, WorksheetResultsSection, WorksheetsResultsMessagesSection } from '../../../../Core';
import { pipe } from 'Lib/Hooks/Selectors';
import ResultsSection from './ResultsSection';
import { useSelector } from 'react-redux';
import { valueOrDefault } from 'Lib/Any';

let ResultsPageSectionBase: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const hasLoadIncrements: boolean = useSelector(
    pipe(createWorksheetSelector!('LoadIncrements'), valueOrDefault([]), (records: any[]) => {
      return records.length > 0;
    })
  );
  return (
    <WorksheetResultsSection heading="Results">
      <NamePrefixModifier namePrefix="pressureChart">{hasLoadIncrements && <ChartSection />}</NamePrefixModifier>
      <NamePrefixModifier namePrefix="settlementChart">{hasLoadIncrements && <ChartSection />}</NamePrefixModifier>
      <ResultsSection />
      <WorksheetsResultsMessagesSection />
    </WorksheetResultsSection>
  );
};

const ResultsPageSection = withInjectedProps(ResultsPageSectionBase);

export default ResultsPageSection;
export { ResultsPageSection };
